module.exports = __webpack_public_path__ + "img/caselist34.9714d68f.jpg";